import { httpClient } from "@/services";

export default {
	state: {
		exception: [],
		exceptionClosed: [],
		exceptionName: '',
		exceptionLimit: null,
		exceptionOrder: null,
		exceptionSort: null,
		exceptionTotal: null,
		exceptionTotals: null,
		exceptionItem: null,
		exceptionStatus: null,
		exceptionActions: [],
		exceptionCount: 0,

		exceptionOpen: [],
		exceptionClose: [],

		exceptionOpenMeta: { limit: null, order: null, sort: null, total: null, totals: null },
		exceptionCloseMeta: { limit: null, order: null, sort: null, total: null, totals: null },

		exceptionOpenLimit: null,
		exceptionOpenOrder: null,
		exceptionOpenSort: null,
		exceptionOpenTotal: null,
		exceptionOpenTotals: null,

		exceptionCloseLimit: null,
		exceptionCloseOrder: null,
		exceptionCloseSort: null,
		exceptionCloseTotal: null,
		exceptionCloseTotals: null,
	},
	mutations: {
		updateException(state, { rows } ) {
			state.exception = rows
				.filter(item => !!item.status)
				.sort((a, b) => b.id - a.id); // сначала больший id

			state.exceptionClosed = rows
				.filter(item => !item.status)
				.sort((a, b) => b.id - a.id);

			state.exceptionCount = state.exception.length;
		},
		updateExceptionCount(state, { count } ) {
			state.exceptionCount = count;
		},
		updateExceptionList(state, payload ) {
			const { type, data } = payload;
			const { rows, limit, order, sort, total } = data;

			const isOpen = Number(type) === 1;

			// ✅ пишем list по типу
			if (isOpen) state.exception = rows;
			else state.exceptionClosed = rows;

			// ✅ пишем meta отдельно по типу
			if (isOpen) {
				state.exceptionOpenLimit = limit;
				state.exceptionOpenOrder = order;
				state.exceptionOpenSort = sort;
				state.exceptionOpenTotal = total;
				state.exceptionOpenTotals = { id: total };
			} else {
				state.exceptionCloseLimit = limit;
				state.exceptionCloseOrder = order;
				state.exceptionCloseSort = sort;
				state.exceptionCloseTotal = total;
				state.exceptionCloseTotals = { id: total };
			}

		},
		updateExceptionItem(state, { row, actions, name, status }) {
			state.exceptionItem = row;
			state.exceptionName = name;
			state.exceptionActions = actions;
			state.exceptionStatus = status;
		},
		updateExceptionActions(state, payload) {
			const user = state.exceptionName;
			state.exceptionActions.push({ user, ...payload });
		}
	},
	actions: {
		async getException({ commit }) {
			try {
				const { data } = await httpClient.get('safety-exception');
				if (data) {
					commit('updateException', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getExceptionCount({ commit }) {
			try {
				const { data } = await httpClient.get('safety-exception/count');
				if (data) {
					commit('updateExceptionCount', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getExceptionList({ commit, dispatch }, dataValue) {
			dispatch("actionPreloader", true);
			const { type, filters } = dataValue;
			try {
				const { data } = await httpClient.post(`safety-exception/${ type }/list`, filters );
				if (data) {
					commit('updateExceptionList', { type, data } );
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onException({ dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('safety-exception', values);
				if (data) {
					dispatch("setAlert", { type: "success", message: "Added new exception" });
					await dispatch('getExceptionList', { type: 1 });
				} else {
					dispatch("setAlert", { type: "error", message: data.error });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async getExceptionItem({ dispatch, commit }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`safety-exception/${ id }/edit`);
				if (data) {
					commit('updateExceptionItem', data);
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onEditExceptionComment({ dispatch }, values) {
			const { id, ...obj } = values;
			dispatch("actionPreloader", true);

			try {
				const { data } = await httpClient.put(`safety-exception/${ id }`, obj);

				if (data) {
					dispatch("setAlert", { type: "success", message: "Comment added successfully" });
					return true;
				}

				dispatch("setAlert", { type: "error", message: data.error });
				return false;
			} catch (e) {
				console.error(e);
				return false;
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async onRemoveException({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`safety-exception/${ id }`);
				if (data) {
					dispatch("setAlert", { type: "success", message: "Exception removed successfully" });
					await dispatch('getExceptionList', { type: 1 });
					await dispatch('getExceptionList', { type: 0 });
				} else {
					dispatch("setAlert", { type: "error", message: data.error });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		onExceptionActions({ commit }, values) {
			commit('updateExceptionActions', values);
		}
	},
	getters: {
		exception: s => s.exception,
		exceptionItem: s => s.exceptionItem,
		exceptionLimit: s => s.exceptionLimit,
		exceptionOrder: s => s.exceptionOrder,
		exceptionSort: s => s.exceptionSort,
		exceptionTotal: s => s.exceptionTotal,
		exceptionTotals: s => s.exceptionTotals,
		exceptionName: s => s.exceptionName,
		exceptionActions: s => s.exceptionActions,
		exceptionClosed: s => s.exceptionClosed,
		exceptionCount: s => s.exceptionCount,
		exceptionStatus: s => s.exceptionStatus,

		exceptionOpenTotal: s => s.exceptionOpenTotal,
		exceptionOpenTotals: s => s.exceptionOpenTotals,
		exceptionOpenOrder: s => s.exceptionOpenOrder,
		exceptionOpenSort: s => s.exceptionOpenSort,
		exceptionOpenLimit: s => s.exceptionOpenLimit,

		exceptionCloseTotal: s => s.exceptionCloseTotal,
		exceptionCloseTotals: s => s.exceptionCloseTotals,
		exceptionCloseOrder: s => s.exceptionCloseOrder,
		exceptionCloseSort: s => s.exceptionCloseSort,
		exceptionCloseLimit: s => s.exceptionCloseLimit,

	}
};
